import './App.css'

import IdentityStyles from "./Identity.module.css"

import { useState, useEffect} from "react"

import { Subject } from "rxjs";

import { v4 as uuid } from "uuid";


import { getAppState, submitTransaction, transferCreatorCoin, getUserData, getDesoPrice } from './lib/deso'


function App() {

  const identityServiceURL = "https://identity.deso.org";

  const [initialized, setInitialized] = useState(false)

  // IDENTITY
  let iframe = null;
  // Requests that were sent before the iframe initialized
  let pendingRequests = [];

  // The currently active identity window
  let identityWindow;
  let identityWindowSubject;  

  // Store the identity users in localStorage
  const IdentityUsersKey = "identityUsers";  

  // Store last logged in user public key in localStorage
  const LastLoggedInUserKey = "lastLoggedInUser";

  // User data
  // identityServiceUsers;
  // identityServicePublicKeyAdded;  
  const [identityServiceUsers, setIdentityServiceUsersState] = useState()
  const [identityServicePublicKeyAdded, setIdentityServicePublicKeyAdded] = useState()
  // We track logged-in state
  //  loggedInUser: User;
  //  userList: User[] = [];  
  const [loggedInUser, setLoggedInUserState] = useState()
  const [userList, setUserList] = useState([])

  const [userWallet, setUserWallet] = useState([])
  const [loggedUsername, setLoggedUsername] = useState()

  const [transactionData, setTransactionData] = useState(null)

  const [desoPriceUSD, setDesoPriceUSD] = useState(null)
  

  // Send a new message and expect a response
  const send = (method, payload) => {
    const req = {
      id: uuid(),
      method,
      payload,
      service: "identity",
    };

    //const subject = new Subject();
    postMessage(req);
    // let newRwquest = {}
    // newRwquest[req.id] = subject;
    // setOutboundRequests(newRwquest)

    //return subject;
  }

  const sign = (payload) => {
    return send("sign", payload);
  }  

  const handleInitialize = (event) => {
    if (!initialized) {
      // initialized = true;
      setInitialized(true)
      iframe = document.getElementById("identity"); // this id of iframe of DeSo Identity Service 
      for (const request of pendingRequests) {
        console.log("postMessage(request)")
        postMessage(request);
      }
      pendingRequests = [];
    }

    // acknowledge, provides hostname data
    console.log("respond(event.source, event.data.id, {})")
    respond(event.source, event.data.id, {});
  }

  const handleLogin = (payload) => {
    if(identityWindow){
      identityWindow.close();
      identityWindow = null;
  
      identityWindowSubject.next(payload);
      identityWindowSubject.complete();
      identityWindowSubject = null;
    }
  }  

  // Respond to a received message
  const respond = (window, id, payload) => {
    window.postMessage({ id, service: "identity", payload }, "*");
  }  

  const postMessage = (req) => {
    if (initialized) {
      iframe = document.getElementById("identity"); // this id of iframe of DeSo Identity Service 
      iframe.contentWindow.postMessage(req, "*");
    } else {
      pendingRequests.push(req);
    }
  }  

  const handleRequest = (event) => {
    const {
      data: { id, method, payload },
    } = event;

    if (method === "initialize") {
      console.log("handleInitialize")
      handleInitialize(event);
    } else if (method === "storageGranted") {
      console.log("handleStorageGranted")
      //handleStorageGranted();
    } else if (method === "login") {
      console.log("handleLogin")
      handleLogin(payload);
    } else if (method === "info") {
      console.log("handleInfo: ", id)
      //handleInfo(id);
    } else {
      console.error("Unhandled identity request");
      console.error(event);
    }
  }

  useEffect(() => {
    async function sendSignedTransaction() {
      if(transactionData && transactionData.payload){
        console.log("transactionData: ", transactionData)
        let signedTx = transactionData.payload.signedTransactionHex
        // submit signed transaction
        let result = await submitTransaction({signedTx})
        console.log("result after signed transaction submitted: ", result) 

        let {error} = result
        if(error){
          console.log("Error: ", error)
        }else{
          // if no error set status of transferedCoin to complete
          // transferedCoin, setTransferedCoin
          console.log("Transfered coin: ", transferedCoin)
          // find transfered coin CreatorPublicKeyBase58Check in wallet list
          console.log("coinTransferStatus: ", coinTransferStatus)

          console.log("result: ", result)

          // get TxnHashHex from result 
          // get transfer details
          // get username 

          // see userWallet, find coin that has Status === 'started' and remove it from wallet
          // update wallet
          // call send coin function
          let walletData = [...userWallet]
          walletData = walletData.filter(coin => !coin.Status)     
          console.log("walletData: ", walletData)
          setUserWallet(walletData)

          setCointSent(true)
          console.log("Send another coin only after sent coin removed from wallet")
          //sendCoin()
        }


        // one coin sold
        // go read wallet and remove first checked coin from the list

        // update wallet here

        // proceed selling next coin
        // call sell coin
      }
    }
    sendSignedTransaction();
  }, [transactionData])

  const handleResponse = (event) => {
    const { data } = event;
 
    setTransactionData(data)

  }  

  // Launch a new identity window
  const launch = (
    path,
    params
  ) => {
    let url = identityServiceURL // identityServiceURL;
    if (path) {
      url += path;
    }

    //let httpParams = new URLSearchParams(url);
    let httpParams = new URLSearchParams();

    if (params.publicKey) {
      httpParams.append("publicKey", params.publicKey);
    }

    if (params.tx) {
      httpParams.append("tx", params.tx);
    }

    if (params.referralCode) {
      httpParams.append("referralCode", params.referralCode);
    }

    if (params.public_key) {
      httpParams.append("public_key", params.public_key);
    }

    if (params.hideJumio) {
      httpParams.append("hideJumio", params.hideJumio.toString());
    }

    if (params.accessLevelRequest) {
      httpParams.append("accessLevelRequest", params.accessLevelRequest.toString());
    }

    const paramsStr = httpParams.toString();
    if (paramsStr) {
      url += `?${paramsStr}`;
    }

    // center the window
    const h = 1000;
    const w = 800;
    const y = window.outerHeight / 2 + window.screenY - h / 2;
    const x = window.outerWidth / 2 + window.screenX - w / 2;

    identityWindow = window.open(url, null, `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`);
    identityWindowSubject = new Subject();

    return identityWindowSubject;
  }  

  const SetStorage = (key, value) => {
    localStorage.setItem(key, value || value === false ? JSON.stringify(value) : "");
  }  

  // Stores identity service users in identityService and localStorage
  const setIdentityServiceUsers = (users, publicKeyAdded) => {
    SetStorage(IdentityUsersKey, users);
    // identityServiceUsers = users;
    // identityServicePublicKeyAdded = publicKeyAdded;
    setIdentityServiceUsersState(users)
    setIdentityServicePublicKeyAdded(publicKeyAdded)  
  }  

  // NEVER change loggedInUser property directly. Use this method instead.
  const setLoggedInUser = (user) => {
    const isSameUserAsBefore = loggedInUser && user && loggedInUser.PublicKeyBase58Check === user.PublicKeyBase58Check;

    setLoggedInUserState(user)
    //loggedInUser = user;


    if (!isSameUserAsBefore) {
      // Store the user in localStorage
      SetStorage(LastLoggedInUserKey, user?.PublicKeyBase58Check);
    }

  }  

  const launchIdentityFlow = (event) => {
      console.log(`account : ${event} : launch`);
      launch("/log-in", {
          accessLevelRequest: "2",
          hideJumio: true,
      })
      .subscribe((res) => {
          console.log(`account : ${event} : success`);
          console.log("res.users: ", res.users)
          console.log("res.publicKeyAdded: ", res.publicKeyAdded)
          setIdentityServiceUsers(res.users, res.publicKeyAdded);

          setUserList(res.users)

          setLoggedInUser({
            PublicKeyBase58Check: res.publicKeyAdded
          })

      });
  }     

  const launchLogoutFlow = () => {
    const publicKey = loggedInUser.PublicKeyBase58Check;
    launch("/logout", { publicKey }).subscribe((res) => {
      console.log("res: ", res)

      setUserList([])
      setLoggedInUser(null);
      setUserWallet([])

      setIdentityServiceUsers([], null);      

    });
  }  

  // Helpers
  const identityServiceParamsForKey = (publicKey) => {
    const { encryptedSeedHex, accessLevel, accessLevelHmac } = identityServiceUsers[publicKey];
    return { encryptedSeedHex, accessLevel, accessLevelHmac };
  }  
  // IDENTITY




  useEffect(() => {

    const handleMessage = (event) => {
      const { data } = event;
      const { service, method } = data;

      if (service !== "identity") {
        return;
      }

      // Methods are present on incoming requests but not responses
      if (method) {
        console.log("handle request")
        handleRequest(event);
      } else {
        console.log("handle response")
        handleResponse(event);
      }
    } 


    window.addEventListener("message", (event) => handleMessage(event));

    // these functions clean up the event listeners
    return () => window.removeEventListener("click", handleMessage)
  })     

  useEffect(() => {

    console.log("====logged user changed====")
    console.log("identityServiceUsers: ", identityServiceUsers)
    console.log("identityServicePublicKeyAdded: ", identityServicePublicKeyAdded)      

    console.log("userList: ", userList)

  },[identityServiceUsers, identityServicePublicKeyAdded, userList])    

  useEffect(() => {
    // run Init on load
    console.log("Run Init on page load")

    // async function getNodeFees() {
    //   console.log("Get App State")
    //   let result = await getAppState()

    //   let {TransactionFeeMap} = result

    //   if(TransactionFeeMap){
    //     //setTransactionFeeMap(TransactionFeeMap)
    //     console.log("setTransactionFeeMap: ", TransactionFeeMap)
    //   }

    // }

    // getNodeFees();    

  }, [])
  

  const login = () => {
    console.log("login")
    launchIdentityFlow("login");
  }

  const logout = () => {
    console.log("logout")
    launchLogoutFlow("logout")
  }    

  const [transferedCoin, setTransferedCoin] = useState(null)
  const [coinTransferStatus, setCoinTransferStatus] = useState(null)

  const [coinSent, setCointSent] = useState(false)

  const sendCoin = async () => {
    let BASIC_TRANSFER = 1000

    let result = await getAppState()
    let {TransactionFeeMap} = result
    if(TransactionFeeMap?.BASIC_TRANSFER){
      console.log("TransactionFeeMap: ", TransactionFeeMap)
      //setTransactionFeeMap(TransactionFeeMap)
      //console.log("setTransactionFeeMap: ", TransactionFeeMap)
      BASIC_TRANSFER = TransactionFeeMap.BASIC_TRANSFER[0].AmountNanos
    } 

    console.log("BASIC_TRANSFER: ", BASIC_TRANSFER)


    // send coins
    let {PublicKeyBase58Check} = loggedInUser
    console.log("send coin")

    // find 1st coin in a list to send and send it
    const firstCheckedCoin = userWallet.find(coin => coin.Selected);

    console.log("firstCheckedCoin: ", firstCheckedCoin);

    if(firstCheckedCoin){

      let {ProfileEntryResponse, BalanceNanos, CreatorPublicKeyBase58Check} = firstCheckedCoin

      console.log("Sending: ", ProfileEntryResponse.Username)
      console.log("Amount: ", BalanceNanos/1e9)      

      let settings = {
        CreatorCoinToTransferNanos: BalanceNanos,
        CreatorPublicKeyBase58Check: CreatorPublicKeyBase58Check,
        ReceiverUsernameOrPublicKeyBase58Check: walletAddress,
        SenderPublicKeyBase58Check: PublicKeyBase58Check,
        MinFeeRateNanosPerKB: BASIC_TRANSFER,      
      }
      result = await transferCreatorCoin(settings)
      let {error, TransactionHex} = result
      if(error){
        console.log("error: ", error)
      } else {
        console.log("result: ", result)

        setTransferedCoin(firstCheckedCoin)

        setCoinTransferStatus({
          CreatorPublicKeyBase58Check,
          status: 'started'
        })

        // set status of this coin in wallet to started 
        // const firstCheckedCoin = userWallet.find(coin => coin.Selected);
        let walletData = [...userWallet]
        walletData = walletData.map(coin => {
          // CreatorPublicKeyBase58Check
          if(coin.CreatorPublicKeyBase58Check === CreatorPublicKeyBase58Check){
            return {...coin, Status:'started'}
          }else{
            return coin
          }
        })
        console.log("walletData: ", walletData)
        // update userWallet
        setUserWallet(walletData)
        

        sign({
          transactionHex: TransactionHex,
          ...identityServiceParamsForKey(PublicKeyBase58Check),
        })  
      }      

    }else{
      console.log("No more coins to transfer...")
    }


    // loop throgh wallet and send selected coins only
    // userWallet.forEach(async({ProfileEntryResponse, BalanceNanos, Selected, CreatorPublicKeyBase58Check}) => {
    //   if(Selected){
    //     // send this coin
    //     console.log("Sending: ", ProfileEntryResponse.Username)
    //     console.log("Amount: ", BalanceNanos/1e9)

    //     let settings = {
    //       CreatorCoinToTransferNanos: BalanceNanos,
    //       CreatorPublicKeyBase58Check: CreatorPublicKeyBase58Check,
    //       ReceiverUsernameOrPublicKeyBase58Check: walletAddress,
    //       SenderPublicKeyBase58Check: PublicKeyBase58Check,
    //       MinFeeRateNanosPerKB: BASIC_TRANSFER,      
    //     }
    //     result = await transferCreatorCoin(settings)
    //     let {error, TransactionHex} = result
    //     if(error){
    //       console.log("error: ", error)
    //     }
    //     console.log("result: ", result)


    //     sign({
    //       transactionHex: TransactionHex,
    //       ...identityServiceParamsForKey(PublicKeyBase58Check),
    //     })    


    //   }
    // })


    // let settings = {
    //   CreatorCoinToTransferNanos: 1409959,
    //   CreatorPublicKeyBase58Check: 'BC1YLiennSTcQm9QjE9LE8n91fVc34UgAaemfVrPQxCeVYxrMd39A5Y',
    //   ReceiverUsernameOrPublicKeyBase58Check: walletAddress,
    //   SenderPublicKeyBase58Check: PublicKeyBase58Check,
    //   MinFeeRateNanosPerKB: BASIC_TRANSFER,      
    // }
    // result = await transferCreatorCoin(settings)
    // let {error, TransactionHex} = result
    // if(error){
    //   console.log("error: ", error)
    // }
    // console.log("result: ", result)

    // sign({
    //   transactionHex: TransactionHex,
    //   ...identityServiceParamsForKey(PublicKeyBase58Check),
    // })    
    

  }

  useEffect(() => {
    // check if there is any coin with Status started in userWallet
    let transferring = false
    userWallet.forEach(coin => {
      if(coin.Status === 'started'){
        transferring = true
      }
    })

    if(coinSent && !transferring){
      setCointSent(false)
      // 
      console.log("Can send another coin")
      sendCoin()
    }
  },[coinSent, userWallet])


  useEffect(() => {
    // run Init on load
    console.log("Logged as ",loggedInUser)
  
    async function getUserDetailsData() {

      let result
      
      // get deso price 1st
      console.log("Getting DeSo price...")
      result = await getDesoPrice()
      let {errors, data} = result
      if(errors){
        console.log("errors: ", errors)
      }
      if(data){
        console.log("data: ", data)
        setDesoPriceUSD(data.amount)
      }

      // now load wallet
      console.log("Loading wallet...")

      let {PublicKeyBase58Check} = loggedInUser
  
      let settings = {
        PublicKeysBase58Check: [PublicKeyBase58Check]      
      }
      result = await getUserData(settings)
      let {error, UserList} = result
      if(error){
        console.log("error: ", error)
      }
      if(UserList){
        //setLoggedUsername
        console.log("UserList[0]: ", UserList[0].ProfileEntryResponse.Username)
        setLoggedUsername(UserList[0].ProfileEntryResponse.Username)

        let walletData = UserList[0].UsersYouHODL.map(coin=> ({ ...coin, Selected: true }))

        walletData = walletData.filter(coin => coin.BalanceNanos)

        // filter out BalanceNanos = 0

        // let walletData = UserList[0].UsersYouHODL
        console.log("walletData: ", walletData)
        setUserWallet(walletData)


        
      }
      
    }

    if(loggedInUser){
      getUserDetailsData();  
    }
       
    
  }, [loggedInUser])

  const [allSelected, setAllSelected] = useState(true)

  const [walletAddress, setWalletAddress] = useState('')


  const toggleSelectAllCoins = () => {

    let walletData
    if(allSelected){
      walletData = userWallet.map(obj=> ({ ...obj, Selected: false }))
    }else{
      walletData = userWallet.map(obj=> ({ ...obj, Selected: true }))
    }
    
    setUserWallet(walletData)

    setAllSelected(!allSelected)
  }

  const isAllSelected = (walletData) => {

    let allSelected = true

    walletData.forEach(creator => {
      if(!creator.Selected){
        allSelected = false
      }
    });

    return allSelected
  }

  const updateSelectedCoins = (index) => {
    console.log("Update selected coins: ", index)

    let walletData = [...userWallet]
    walletData[index].Selected = !walletData[index].Selected 
    setUserWallet(walletData)

    if(isAllSelected(walletData)){
      setAllSelected(true) 
    }else{
      setAllSelected(false)
    }
  }


  return (
    <div>

      <div>
        <iframe
          title="Deso Identity"
          className={IdentityStyles.identityIframe}
          id="identity"
          frameBorder="0"
          src="https://identity.deso.org/embed"
        ></iframe>        
      </div>

      <div>

        <div>            

            {
              loggedInUser 
              ?
              <button onClick={logout}>Log out</button>  
              :
              <button onClick={login}>Log in</button>
            }
                    
        </div>

        {
          loggedInUser && loggedInUser && <div>Logged user Public Key: {loggedInUser.PublicKeyBase58Check}</div>
        }

        {
          loggedInUser && loggedUsername && <div>Logged as {loggedUsername}</div>
        }

        {
          loggedInUser && loggedUsername &&
          <div>
            <input type="text" placeholder='wallet address' value={walletAddress} onChange={e => setWalletAddress(e.target.value)}/> 
            <button onClick={sendCoin}>Send Coins</button>
          </div>          
        }

        {
          desoPriceUSD &&
          <div>
            1 DESO = {desoPriceUSD} USD
          </div>          
        }

        { desoPriceUSD && userWallet && userWallet.length > 0 &&
        <>
          <div>Number of Creator Coins owned: {userWallet.length}</div>
          <table className='wallet'>
            <thead>
              <tr>
                <th>Username</th>
                <th>Coin Price</th>
                <th>Coins</th>
                <th>USD Value</th>
                <th><input type="checkbox" checked={allSelected} onChange={() => toggleSelectAllCoins()} /></th>
              </tr>
            </thead>
            <tbody>
            {
              userWallet.map(({ProfileEntryResponse, BalanceNanos, Selected}, index ) => 
                <tr key={index} className='row'>
                  <td>{ProfileEntryResponse.Username}</td>

                  <td>${Math.round( (ProfileEntryResponse.CoinPriceDeSoNanos/1e9*desoPriceUSD) * 100 + Number.EPSILON ) / 100}</td>

                  <td>{BalanceNanos/1e9}</td>

                  <td>${Math.round( ((ProfileEntryResponse.CoinPriceDeSoNanos/1e9*desoPriceUSD) * (BalanceNanos/1e9)) * 100 + Number.EPSILON ) / 100}</td>

                  <td>
                      <input type="checkbox" checked={Selected} onChange={() => updateSelectedCoins(index)} />
                  </td>

                </tr>
              )
            }
            </tbody>
          </table>
        </>
        }

       

      </div>

    </div>
  );
}

export default App;
